import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

export function formatDates(startDate?: any, endDate?: any, timeZone: string = 'UTC') {
  if (!startDate) return

  const dayFunction = getDayFunction(timeZone)
  const s = dayFunction(startDate)
  const e = dayFunction(endDate)
  const sameDay = s.isSame(e, 'day')
  if (!endDate || sameDay) return s.format('MMM D, YYYY')

  const sameMonth = s.isSame(e, 'month')
  const sameYear = s.isSame(e, 'year')
  const startFormatter = `MMM D${sameYear ? '' : ', YYYY'}`
  const endFormatter = `${sameMonth ? '-' : ' - MMM '}D, YYYY`
  return `${s.format(startFormatter)}${e.format(endFormatter)}`
}

export function getDayFunction(timeZone: string) {
  switch (timeZone) {
    case 'local':
      return dayjs
    case 'UTC':
      return dayjs.utc
    default:
      return (d?: LooseDate) => dayjs.tz(d, timeZone)
  }
}

export type LooseDate = Date | number | string
